<template>
  <div class="swiper-container first-one"
       :style="`width:${width};height:${height}`">
    <div class="swiper-wrapper">
      <div class="swiper-slide">
        <dataCenter @carousel='carousel()' />
      </div>
      <div class="swiper-slide">
        <weatherCenter @carousel='carousel()' />
      </div>
      <div class="swiper-slide">
        <poverty @carousel='carousel()' />
      </div>
    </div>
  </div>
</template>

<script>
import Swiper from 'swiper';
import 'swiper/dist/css/swiper.min.css';
import dataCenter from './components/dataCenter.vue'
import weatherCenter from './components/weatherCenter.vue'
import poverty from './components/poverty.vue'
import setting from './setting'
var mySwiper
var i = 1
let timer
export default {

  data () {
    return {
      width: "0px",
      height: "0px",
      options: {
        pagination: '.swiper-pagination',
        paginationClickable: true,
        speed: 3000,
        disableOnInteraction: false,
        // loop: true,
        observer: true,
        observeParents: true,
        // autoplayDisableOnInteraction: true,
        // autoplay: {
        //   delay: setting.carousel,

        // },

      },
      status: 'up'
    }
  },
  components: {
    dataCenter, weatherCenter, poverty
  },
  mounted () {
    let self = this
    const width = document.body.clientWidth
    const height = document.body.clientHeight
    this.width = width - 2 + 'px'
    this.height = height - 2 + 'px'
    mySwiper = new Swiper('.first-one', this.options)
    timer = setInterval(() => {
      self.resetDirection()
    }, setting.carousel);
    timer
    mySwiper
  },
  methods: {
    carousel () {
      // mySwiper.autoplay.stop()
      // mySwiper.autoplay.start()
      if (i % 2 == 1) { clearInterval(timer) } else {
        timer = setInterval(() => {
          this.resetDirection()
        }, setting.carousel);
        timer
      }

      i++
      console.log(i, timer)
    },
    resetDirection () {
      let index = mySwiper.activeIndex
      console.log(this.status)
      if (this.status == 'up') {
        if (index !== 2) { mySwiper.slideTo(index + 1, 1500, false) } else {
          mySwiper.slideTo(index - 1, 1500, false)
          this.status = 'down'
        }
      } else if (this.status == 'down') {
        if (index > 0) { mySwiper.slideTo(index - 1, 1500, false) } else {
          mySwiper.slideTo(index + 1, 1500, false)
          this.status = 'up'
        }
      }


    }
  }
}
</script>

<style scoped>
.swiper-container {
  color: white;
}
</style>
